<template>
  <div class="img-container">
    <div
      class="img-container__src"
      v-if="img"
      :style="{ backgroundImage: 'url(' + img + ')' }"
    ></div>
    <div class="img-container__index">{{ number + 1 }}</div>
    <div class="img-container__text">{{ text }}</div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style scoped lang="less">
.img-container {
  width: 2.46rem;
  margin-left: 0.5rem;
  text-align: center;
  &__src {
    width: 2.46rem;
    height: 3.8rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 0.16rem;
    margin-bottom: 0.3rem;
  }
  &__index {
    width: 0.3rem;
    height: 0.3rem;
    background-image: url('https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/basic-circle-20220411.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin-left: 50%;
    transform: translateX(-50%);
    position: relative;
    font-family: PingFangSC-Medium;
    font-size: 0.22rem;
    color: #222222;
    font-weight: 500;
    line-height: 0.3rem;
    &::before {
      display: block;
      content: '';
      position: absolute;
      right: 0.37rem;
      top: 50%;
      transform: translateY(-50%) scaleY(1.5);
      width: 1.26rem;
      height: 1px;
      transform-origin: 0 0;
      background: #dbdada;
    }
    &::after {
      display: block;
      content: '';
      position: absolute;
      left: 0.37rem;
      top: 50%;
      transform: translateY(-50%) scaleY(1.5);
      width: 1.26rem;
      height: 1px;
      background: #dbdada;
    }
  }
  &__text {
    font-family: PingFangSC-Medium;
    font-size: 0.22rem;
    color: #222222;
    font-weight: 500;
    line-height: 0.3rem;
    margin-top: 0.17rem;
  }
}
</style>
